export const STATS_TURNOVER_LOADING  = "STATS_TURNOVER_LOADING";
export const SET_TURNOVER  = "SET_TURNOVER";
export const STATS_PROGRESS_OVERVIEW_LOADING  = "STATS_PROGRESS_OVERVIEW_LOADING";
export const SET_PROGRESS_OVERVIEW  = "SET_PROGRESS_OVERVIEW";
export const STATS_UNPAID_INVOICE_LOADING  = "STATS_UNPAID_INVOICE_LOADING";
export const SET_UNPAID_INVOICE_STAT  = "SET_UNPAID_INVOICE_STAT";
export const STATS_STOCK_VALUE_LOADING  = "STATS_STOCK_VALUE_LOADING";
export const SET_STOCK_VALUE  = "SET_STOCK_VALUE";
export const STATS_MANUFACTURERS_LOADING  = "STATS_MANUFACTURERS_LOADING";
export const SET_MANUFACTURERS  = "SET_MANUFACTURERS";